module.exports = __webpack_public_path__ + "img/partner_2.a38165eb.png";